module.exports = __webpack_public_path__ + "img/havefun_kansai_tc.e84a62b7.png";